module.exports = __webpack_public_path__ + "img/undraw_security_o890.39c7068a.svg";